import clsx from 'clsx';
import React from 'react';

import ForYouSectionHeader from './SectionHeader';
import type { ForYouSectionProps } from './interfaces';

const ForYouSection = ({
  children,
  className,
  disableBorder = false,
  highlight,
  id,
  subtitle,
  title,
}: ForYouSectionProps) => {
  return (
    <article
      className={clsx(
        'mt-48 scroll-mt-56 border-0 sm:mt-64 nav:scroll-mt-64',
        !disableBorder && 'border-t border-solid border-grayscale-gray pt-48 sm:pt-64',
        className
      )}
      id={id}
    >
      <ForYouSectionHeader highlight={highlight} subtitle={subtitle} title={title} />
      {children}
    </article>
  );
};

export default ForYouSection;
